

































































































































































































































































































































































































import DropDownLanguages from "@/components/NavLanguage/dropDownLanguages.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import "./navbar.css";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseApi from "@/core/HttpResources/BaseApi";
//import Notificacion from "@/models/notificacion/notificacion.model";
import * as signalR from "@aspnet/signalr";
import UserService from "@/services/user.service";
import pdfvuer from "pdfvuer";

import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import ProporsalNotification from "@/models/porposal/proposalNotification.Model";
import ProporsalproporsalNotificationService from "@/services/proposalNotification.service";
import User from "@/models/security/user.model";
//import UsuarioService from "@/services/usuario.service";
import UserResearchCenterService from "../../../services/UserResearchCenter.service";
import { ProposalNotificationType } from "../../../enums/proposalNotificactionType";

@Component({
  components: {
    DropDownLanguages,
  },
})
export default class NavbarComponent extends Vue {
  notifications: Array<any> = [];

  //usrService = new UsuarioService();
  UserResearchCenterService: UserResearchCenterService = new UserResearchCenterService();
  loadingChangePasswordSave = false;
  showChangePassword = false;
  isCardModalActive = false;
  pdfdata: any = null;
  numPages: number = 0;
isImageModalActive =  false;
  numbersNotification: ProporsalNotification[] = [];
  isAdminCenter = false;
  headers = {
    Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
  };
  userRequested: User | null = null;
  isVisible = false;
  $buefy: any;
  areAllNotificaction = false;
  proporsalNotificationService: ProporsalproporsalNotificationService;
  proporsalNotifications: ProporsalNotification[] = [];
  userService: UserService = new UserService();
  loading = false;
  proposalNotificationType = ProposalNotificationType;

  markingAsReadProporsalNotification = false;
  connection: any = null;
  constructor() {
    super();
    this.proporsalNotificationService = new ProporsalproporsalNotificationService();
  }

  openIntruction(){
    window.open("/pdf/instrutivo.pdf", "Instrutivo");
  }

  @Watch("user")
  onChangeUser() {
    if (!this.user) {
      this.doLogOut();
    }
  }
  showDropDown(e) {
    console.log(e);
  }
  get userStorage() {
    return this.$store.state.user;
  }
  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  get user() {
    var user = this.$authService.getAccount();
    if (!user) {
      this.doLogOut();
    }
    return user;
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  get getProfileImage() {
    if (this.userRequested && this.userRequested.profileImage)
      return `data:image/jpg;base64, ${this.userRequested.profileImage}`;

    return false;
  }
  //  async getNotificationNumber(){
  //
  //     this.numbersNotification = await this.proporsalNotificationService.GetNotificactionNumber(this.userStorage.id);

  //   }
  getAdminResearchCenter() {
    this.UserResearchCenterService.getResearchCenterAdmin(
      this.userStorage.id
    ).then((response) => {
      this.isAdminCenter = response;
    });
  }

  getUser() {
    this.loading = true;
    this.userService
      .getUserById(this.userStorage.id)
      .then((user) => {
        this.userRequested = user;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  getImage() {
    return `data:image/jpg;base64, ${this.userStorage.profileImage}`;
  }
  buildSignalRConnection() {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_BASE_API_URL + "hub")
      .configureLogging(signalR.LogLevel.Information)
      .build();
  }
  registerSignalRInterceptor() {
    this.connection.start().catch((err: any) => {
      // document.write("signalR: " + err);
    });
    this.connection.on("proporsalSended", this.notificationReceived);

    this.connection.onclose(async () => {
      this.buildSignalRConnection();
      await this.registerSignalRInterceptor();
    });
  }

  notificationReceived(userIDs: number[]) {
    for (let i = 0; i < userIDs.length; i++) {
      const userID = userIDs[i];
      if (this.userStorage.id == userID) {
        this.getNotifications();
      }
    }
  }
  searchMessage(id: number) {}

  async getNotifications() {
    this.proporsalNotifications = await this.proporsalNotificationService.LastNotifications(
      this.userStorage.id
    );
  }

  async getAllNotifiacion() {
    this.proporsalNotifications = await this.proporsalNotificationService.ViewAllNotifications(
      this.userStorage.id
    );

    this.areAllNotificaction = true;
  }


  async markAsReadProporsalNotification(item: ProporsalNotification) {
    if (item) {
      debugger
      if (!item.read) {
        this.markingAsReadProporsalNotification = true;
        let result = await this.proporsalNotificationService.MarkAsRead(item);
        if (result.read) {
          this.getNotifications();
           

         if (item.roleRequestId && item.state === ProposalNotificationType.InvestigatorResearchCenter ) {
            this.$router.push(
              `/solicitud-role-admin-research-center/view/${item.roleRequestId}`
            );
          } else if (item.annoucementId && item.state === ProposalNotificationType.NewAnnoucement) {
            
            this.$router.push(`/convocatoria/detail/${item.annoucementId}`);
          } else if (
            item.state == this.proposalNotificationType.NewReport ||
            item.state == this.proposalNotificationType.FinalReport
          ) {
            this.$router.push(`/recived-reports-ies`);
          } else if (
            item.state == this.proposalNotificationType.ReportEvaluator
          ) {
            this.$router.push(`/proposal/pendingReports/evaluations`);
          }else if(item.state === this.proposalNotificationType.NewProposal){
            this.$router.push(`/convocatoria/propuesta/${item.proposalId}/detail`);
          }
          else if(item.state === this.proposalNotificationType.ReturnedBack){
               this.$router.push(`/convocatoria/propuesta/${item.proposalId}`);
          }
           else if(item.state == this.proposalNotificationType.Evaluator){
            this.$router.push(`/proposal-pending-evaluations`);
          }
          else if(item.state == this.proposalNotificationType.EvaluatorHasEvaluated){
          this.$router.push(`/convocatoria/propuesta/${item.proposalId}/detail`);
          }
        }
      }
      if (
        item.state == this.proposalNotificationType.NewReport ||
        item.state == this.proposalNotificationType.FinalReport
      ) {
        this.$router.push(`/recived-reports-ies`);
      } else if (item.state == this.proposalNotificationType.ReportEvaluator && item.read) {
        this.$router.push(`/proposal/pendingReports/evaluations`);
      } else if (item.roleRequestId) {
        this.$router.push(
          `/solicitud-role-admin-research-center/view/${item.roleRequestId}`
        );
      } else if (item.annoucementId && item.state === ProposalNotificationType.NewAnnoucement && item.read) {
        this.$router.push(`convocatoria/detail/${item.annoucementId}`);
      } 
      else if(item.state === this.proposalNotificationType.NewProposal && item.read){
            this.$router.push(`/convocatoria/propuesta/${item.proposalId}/detail`);
          }
               else if(item.state === this.proposalNotificationType.ReturnedBack && item.read){
               this.$router.push(`/convocatoria/propuesta/${item.proposalId}`);
          }
      else if(item.state === ProposalNotificationType.Evaluator && item.read) {
        this.$router.push(`/proposal-pending-evaluations`);
      }
      this.markingAsReadProporsalNotification = false;
    }
  }

  logout() {
    this.$buefy.dialog.confirm({
      title: "Cerrando sesión",
      message: "¿Desea cerrar sesión?",
      confirmText: "Cerrar sesión",
      type: "is-primary",
      hasIcon: true,
      cancelText: "Cancelar",
      onConfirm: () => {
        this.doLogOut();
      },
    });
  }
  toggleVisibility(e: any) {
    document.getElementById("div-who-show-dropdown").className =
      "navbar-item has-dropdown is-hoverable";
    console.log(e.target);
    this.isVisible = !this.isVisible;
  }

  doLogOut() {
    localStorage.clear();
    sessionStorage.clear();
    this.$authService.logout();
  }

  created() {
    this.getNotifications();
    this.buildSignalRConnection();
    this.registerSignalRInterceptor();
  }
  mounted() {
    this.getAdminResearchCenter();
     var self = this;
    self.pdfdata = pdfvuer.createLoadingTask("/pdf/instrutivo.pdf");
    self.pdfdata.then((pdf: any) => {
      self.numPages = pdf.numPages;
    });
  }
  beforeMount() {
    this.getUser();
  }
  sendToHome() {
    this.$router.push(`/`);
  }
  sendToUserInfo() {
    this.isCardModalActive = true;
  }
  sendToProfile() {
    this.$router.push(`/profile`);
  }
  sendToChangeRol() {
    this.$router.push(`/profile/changeRol`);
  }
  sendToCv() {
    this.$router.push("/curriculum/" + this.userStorage.id);
  }
}
